import { FC, useRef } from 'react'

import cx from 'clsx'
import { useOpenMenu } from 'hooks/useOpenMenu'
import { useCategoryMarketDemo } from 'modules/categoryMarketGrowth/hooks/useCategoryMarketDemo'
import { Loader, LoaderTypes } from 'ui/Loader'

import classes from './CategoryMarketGrowthDashboard.module.scss'

interface CategoryMarketGrowthDashboardProps {
  className?: string
}

export const CategoryMarketGrowthDashboard: FC<CategoryMarketGrowthDashboardProps> = ({ className }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const openMenu = useOpenMenu((state) => state.open)
  const { hasError, isLoading } = useCategoryMarketDemo(containerRef)

  return (
    <div className={cx(classes.wrap, className, { [classes.open]: openMenu })}>
      <div className={classes.scroll}>
        <div className={classes.cont}>
          {isLoading && <Loader className={classes.loader} type={LoaderTypes.SpinnerCenter} />}
          {hasError && <div className={classes.error}>Не удалось загрузить демо «Рост рынка»</div>}
          <div className={classes.root} ref={containerRef} />
        </div>
      </div>
    </div>
  )
}
